type AnimationFunction = (
  element: HTMLElement,
  config?: KeyframeAnimationOptions
) => Animation;
export default class AnimationManager {
  private static defaultFactoryConfig: KeyframeAnimationOptions = {
    duration: 250,
    iterations: 1,
    fill: "forwards",
    easing: "ease-in",
  };

  public static create(
    keyframes: Keyframe[] | ((element?: HTMLElement) => Keyframe[]),
    defaultAnimationConfig?: KeyframeAnimationOptions
  ): AnimationFunction {
    return (element: HTMLElement, config?: KeyframeAnimationOptions) => {
      const computedKeyframes =
        typeof keyframes === "function" ? keyframes(element) : keyframes;

      return element.animate(computedKeyframes, {
        ...this.defaultFactoryConfig,
        ...defaultAnimationConfig,
        ...config,
      });
    };
  }

  public static async stop(animation: Animation) : Promise<void> {
    animation.cancel();
    await animation.finished;
  }

  public static commintAndStop(animation: Animation) : void {
    animation.pause();
    animation.commitStyles();
    animation.cancel();
  }
}
